export const GET_USER_SPECIFIC_DATA_QUERY_KEY = ['userSpecificData'] as const;
